import cx from 'classnames'
import { useRouter } from 'next/navigation'

import { Picture } from 'src/components/Picture'
import { ImageType, type PictureProps } from 'src/components/Picture/Picture.types'
import { useThemeContext } from 'theme/themeProvider'

import { getProviderTitle, providerCodeTransform } from '../../utils/providersNaming'

import classes from './styles.module.scss'

import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'
import type { SupportedCurrencies } from 'types/currencies'

type Props = {
  provider: Provider
  role?: string
  activeCurrency: SupportedCurrencies
  className?: string
}

export default function ProviderTile(props: Props) {
  const router = useRouter()
  const { isDarkMode } = useThemeContext()
  const providerCode = providerCodeTransform(props.provider.code)
  const pictureProps: PictureProps = {
    src: `${process.env.IMG_ORIGIN}/game-providers/${providerCode}.png`,
    alt: props.provider.title,
    className: classes.image,
    type: ImageType.TILE,
    loading: 'lazy',
    isWebpFirst: false,
  }

  const handleTileClick = () => {
    router.push(`/providers/${props.provider.code}`)
  }

  return (
    <div className={cx(classes.root, props?.className)} onClick={handleTileClick}>
      <div
        className={cx(classes.imageContainer, isDarkMode && classes.isDarkMode)}
        data-test={`game-tile-${providerCode}`}
      >
        <Picture {...pictureProps} />
      </div>

      <p className={classes.title}>{getProviderTitle(props.provider.title)}</p>
    </div>
  )
}
